class FacetRemove extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['link']
  }

  connectedCallback () {
    super.connectedCallback()

    this.state = {
      context: this.getAttribute('data-context') || 'shopify',
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.link.element, 'click', event => {
      event.preventDefault()


      if (this.state.context === 'shopify') {
        this.filters.onLinkClick(event)
      }

      if (this.state.context === 'nosto') {
        window.theme.results.eventBus.publish(
          window.theme.results.events.UI.FACET_REMOVED,
          {
            field: this.getAttribute('data-filter-label'),
            value: [this.getAttribute('data-filter-value')],
          },
        )
      }
    })
  }

  /**
   * @returns {CollectionFilters|null}
   */
  get filters () {
    return this.closest('collection-filters')
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove)
}
